<ng-container *ngIf="currentFormState$ | async as currentFormState" [ngSwitch]="currentFormState">
  <form [formGroup]="form" class="code-form">
    <ng-template #phoneSection>
      <div class="phone-section">
        <sd-form-field class="phone-section__input" label="Ваш телефон" [isShrinked]="true">
          <input type="tel" class="form-control" formControlName="phone" sdPhoneMaskFix autofocus />
        </sd-form-field>
        <ng-container *ngIf="requestCodeState$ | async as requestCodeState">
          <button sdButton type="accent" [loading]="requestCodeState.loading" (click)="requestCode()">
            Получить код по смс
          </button>
        </ng-container>
      </div>
    </ng-template>

    <ng-container *ngSwitchCase="formStates.RequestCode">
      <ng-container *ngIf="isFeatureBonusSystemAvailable$ | async; else bonusSystemIsUnavailable">
        <div class="subtitle subtitle-bonus-system">
          Если этого номера ещё нет в программе лояльности, мы подключим его - вам будет доступно начисление и списание
          бонусных баллов
        </div>

        <ng-container [ngTemplateOutlet]="phoneSection"></ng-container>

        <ng-container *ngIf="canRegister$ | async; else captionWithoutRegistration">
          <div class="caption">
            Нажимая «Получить код», я подтверждаю согласие с условиями участия в
            <a sdLink [routerLink]="'/loyalty_program'">программе лояльности</a>
            и
            <a sdLink [routerLink]="'/personal_data'">обработкой персональных данных</a>
          </div>
        </ng-container>

        <ng-template #captionWithoutRegistration>
          <div class="caption">
            Нажимая «Получить код», я подтверждаю согласие с
            <a sdLink [routerLink]="'/personal_data'">политикой обработки персональных данных</a>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #bonusSystemIsUnavailable>
        <h2 class="title">Войдите или зарегистрируйтесь, чтобы продолжить</h2>

        <ng-container [ngTemplateOutlet]="phoneSection"></ng-container>

        <sd-personal-data-agree-text class="agreement"></sd-personal-data-agree-text>
      </ng-template>

      <button class="toggle-auth-method" sdLink (click)="toggleAuthMethod()" type="unset">Вход по паролю</button>
    </ng-container>

    <ng-container *ngSwitchCase="formStates.Login">
      <button sd-navigation-arrow type="button" (click)="goBack()">Назад</button>

      <h2 class="title">Введите код</h2>

      <div class="subtitle">
        Код отправлен на номер
        <br />
        {{ form.controls.phone.value | sdPhoneFormat }}
      </div>

      <sd-form-field class="form-control-code">
        <input
          mask="0000"
          type="tel"
          class="form-control"
          placeholder="Введите код из смс"
          formControlName="code"
          autofocus
        />
        <sd-spinner *ngIf="submitSmsCodeLoading$ | async" class="spinner"></sd-spinner>
      </sd-form-field>

      <ng-container *ngIf="resendTimestamp$ | async as resendTimestamp; else requestNewCodeTpl">
        <div class="caption">
          Получить новый код можно через
          <sd-countdown [untilTimestamp]="resendTimestamp" (completed)="resetResendTimestamp()"></sd-countdown>
        </div>
      </ng-container>

      <ng-template #requestNewCodeTpl>
        <button sdLink type="unset" (click)="requestCode()">Получить новый код</button>
      </ng-template>
    </ng-container>
  </form>
</ng-container>
